import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function Cybersecurity() {
  return <DetailPage type="service" id="cybersecurity" />;
}
